import { render, staticRenderFns } from "./LimitedTimeRulePopup.vue?vue&type=template&id=d508f1d4&scoped=true&"
import script from "./LimitedTimeRulePopup.vue?vue&type=script&lang=js&"
export * from "./LimitedTimeRulePopup.vue?vue&type=script&lang=js&"
import style0 from "./LimitedTimeRulePopup.vue?vue&type=style&index=0&id=d508f1d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d508f1d4",
  null
  
)

export default component.exports